import { render, staticRenderFns } from "./GoalModal.vue?vue&type=template&id=9b62bd3c&scoped=true"
import script from "./GoalModal.vue?vue&type=script&lang=js"
export * from "./GoalModal.vue?vue&type=script&lang=js"
import style0 from "./GoalModal.vue?vue&type=style&index=0&id=9b62bd3c&prod&lang=scss"
import style1 from "./GoalModal.vue?vue&type=style&index=1&id=9b62bd3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b62bd3c",
  null
  
)

export default component.exports